const getRandomNumber = (max = 100) => {
  return Math.floor(Math.random() * max) + 1;
};

const pushToDataLayer = (options) => {
  if (!options.name || !options.version || !options.segment) {
    console.error("Error: Must provide all options to pushToDataLayer");
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "banxa-split-test",
    featureName: options.name,
    featureVersion: options.version,
    cohort: options.segment,
  });
};

const checkExistingCohort = (testName, version = 1) => {
  const existing = localStorage.getItem(testName);

  if (!existing) {
    return null;
  }

  pushToDataLayer({ name: testName, segment: existing, version });

  return existing;
};

const assignCohort = (testName, percentageOfUsers = 50, version = 1) => {
  const value = getRandomNumber() <= percentageOfUsers ? "a" : "b";

  const segmentOptions = {
    name: testName,
    segment: value,
    version,
  };

  localStorage.setItem(testName, value);

  pushToDataLayer(segmentOptions);

  return value;
};

export { getRandomNumber, assignCohort, checkExistingCohort };
